export default __webpack_public_path__ + "i18n/translations/translation-ta.ee4457c1.json";